var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84088 3.27838C8.17038 2.94887 8.70462 2.94887 9.03412 3.27838L19.1591 13.4034C19.4886 13.7329 19.4886 14.2671 19.1591 14.5966L9.03412 24.7216C8.70462 25.0511 8.17038 25.0511 7.84088 24.7216C7.51137 24.3921 7.51137 23.8579 7.84088 23.5284L17.3693 14L7.84088 4.47162C7.51137 4.14212 7.51137 3.60788 7.84088 3.27838Z",
    fill: "#0E0748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevRight);
export default __webpack_public_path__ + "static/media/chevRight.c6f175c6625f1aa39d05a351deea7bca.svg";
export { ForwardRef as ReactComponent };